import React from 'react';
import { Pie } from '@ant-design/charts';
import { Divider } from 'antd';


const PieChart = (props) => {

    let positive = 0;
    let negative = 0;
    let neutral = 0;

    for (let i = 0; i < props.commentData.length; i++) {
        for (let j = 0; j < props.commentData[i].length; j++) {
            if (props.commentData[i][j]['sentiment'] === 'Positive') {
                positive += 1;
            }
            else if (props.commentData[i][j]['sentiment'] === 'Neutral') {
                neutral += 1
            }
            else {
                negative += 1;
            }
        };
    };

    const data = [
        {
            type: 'Positive',
            value: positive,
        },
        {
            type: 'Negative',
            value: negative,
        }
        , {
            type: 'Neutral',
            value: neutral,
        }

    ];

    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
        },
        interactions: [
            {
                type: 'element-active',
            },
        ],
    };
    return (
        <div className='container border' style={{ display: (props.show && !props.isLoading) ? "block" : "none" }}>
            <h2>Sentiment PieChart</h2>
            <p>Pie chart of the sentiment of comments and their replies to know community acceptance overview</p>
            <Divider />
            <Pie {...config} />
        </div>
    );
};

export default PieChart;
